/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_DefaultInputs */

const en_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const fr_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par defaut`)
};

const de_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const it_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinito`)
};

const ru_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По умолчанию`)
};

const es_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por defecto`)
};

const zh_cn2_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认`)
};

const ja_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デフォルト`)
};

const hi_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलती करना`)
};

const pt_pt2_ccsl_export_template_default = /** @type {(inputs: Ccsl_Export_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrão`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Ccsl_Export_Template_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_default = /** @type {((inputs?: Ccsl_Export_Template_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_template_default(inputs)
	if (locale === "de") return de_ccsl_export_template_default(inputs)
	if (locale === "it") return it_ccsl_export_template_default(inputs)
	if (locale === "ru") return ru_ccsl_export_template_default(inputs)
	if (locale === "es") return es_ccsl_export_template_default(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_template_default(inputs)
	if (locale === "ja") return ja_ccsl_export_template_default(inputs)
	if (locale === "hi") return hi_ccsl_export_template_default(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_template_default(inputs)
	return en_ccsl_export_template_default(inputs)
});